import { recordFormView } from '../api/catalog';

const recorded = new Set<string>();

/** V8: once per form version per page load; fire-and-forget. */
export function recordViewOnce(id: number, versionNo: number): void {
  const key = `${id}:${versionNo}`;
  if (recorded.has(key)) return;
  recorded.add(key);
  recordFormView(id).catch(() => {});
}

export function __resetRecordedViewsForTest(): void {
  recorded.clear();
}
